import type { IContextQueryResult } from '@modules/core/services/query/types';
import { AFFILIATE_PROGRAM_CREATIVES_PERMISSIONS } from '@modules/affiliate-program-creatives/constants';
import { useRestClient } from '@modules/core/services/api';
import { useContextQuery } from '@modules/core/services/query';

import type {
  IAffiliateProgramCreativeOptionsResponse,
} from '../types';
import {
  AFFILIATE_PROGRAM_CREATIVES_OPTIONS_QUERY_KEY,
  AFFILIATE_PROGRAM_CREATIVES_OPTIONS_URL,
} from '../constants';

export default function useAffiliateProgramCreativeOptionsQuery(): IContextQueryResult<
  IAffiliateProgramCreativeOptionsResponse
> {
  const { fetchGet } = useRestClient();

  return useContextQuery<
    IAffiliateProgramCreativeOptionsResponse
  >({
    queryKey: [AFFILIATE_PROGRAM_CREATIVES_OPTIONS_QUERY_KEY],
    queryFn: ({ signal }) => fetchGet<IAffiliateProgramCreativeOptionsResponse>(
      AFFILIATE_PROGRAM_CREATIVES_OPTIONS_URL,
      {
        signal,
        permission: AFFILIATE_PROGRAM_CREATIVES_PERMISSIONS.CREATE,
      },
    ),
  });
}
